import request from "../utils/request";
import "../interfaces/capsule";



/**
 * Creates a new capsule.
 * @param {NewCapsule} capsule - The capsule data to create.
 * @returns {Promise<any>} The response from the API.
 */
export const createCapsule = async (capsule) => {
    try {
        const response = await request.post("/capsules/createCapsule", capsule);
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

export const deleteCapsule = async (capsuleId, userId) => {
    try {
        const response = await request.delete("/capsules/deleteCapsule", { capsuleId, userId });
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw error to be handled by the caller
    }
}

/**
 * Fetches dashboard data (capsules and ads).
 * @param {number} page - The page number to fetch.
 * @param {number} limit - The number of items per page.
 * @param {string} statusFilter - The status filter for capsules (e.g., "Locked").
 * @returns {Promise<DashboardItem[]>} The dashboard data.
 */
export const getDashboardData = async (page = 1, limit = 10, statusFilter) => {
    try {
        const response = await request.get(`/capsules/dashboard`, {
            params: { page, limit, statusFilter },
        });
        return response.data; // Return the dashboard data
    } catch (error) {
        console.error("Error fetching dashboard data:", error);
        throw error; // Throw error to be handled by the caller
    }
};


/**
 * Fetches capsule details by ID.
 * @param {string} capsuleId - The ID of the capsule to fetch.
 * @returns {Promise<any>} The capsule details.
 */
export const getCapsuleInfo = async (capsuleId) => {
    try {
        const response = await request.get(`/capsules/detail/${capsuleId}`);
        return response.data; // Return the capsule details
    } catch (error) {
        console.error("Error fetching capsule details:", error);
        throw error; // Throw error to be handled by the caller
    }
};

/**
 * Fetches dashboard data (capsules and ads).
 * @param {number} page - The page number to fetch.
 * @param {number} limit - The number of items per page.
 * @param {string} statusFilter - The status filter for capsules (e.g., "Locked").
 * @returns {Promise<any>} The dashboard data.
 */

export const getMyCapsules = async (page = 1, limit = 10, statusFilter) => {
    try {
        const response = await request.get(`/capsules/my-capsules`, {
            params: { page, limit, statusFilter },
        });
        return response.data; // Return the dashboard data
    } catch (error) {
        console.error("Error fetching dashboard data:", error);
        throw error; // Throw error to be handled by the caller
    }
}

export const requestOpenCapsule = async (capsuleId) => {
    try {
        const response = await request.post(`/capsules/${capsuleId}/open-request`);
        return response.data; // Return the response data
    } catch (error) {
        console.error("Error opening capsule:", error);
        throw error; // Throw error to be handled by the caller
    }
};

export const getCapsuleRecallQuestion = async (capsuleId) => {
    try {
        const response = await request.get(`/capsules/${capsuleId}/questions`);
        return response.data; // Return the recall question data
    } catch (error) {
        console.error("Error fetching capsule recall question:", error);
        throw error; // Throw error to be handled by the caller
    }
}

export const answerRecallQuestion = async (questionId, answer, capsuleId) => {
    try {
        const response = await request.post(`/capsules/${capsuleId}/questions/${questionId}/answer`, { questionId, answer });
        return response.data; // Return the response data
    } catch (error) {
        console.error("Error answering recall question:", error);
        throw error; // Throw error to be handled by the caller
    }
}

export const getExplainAnswer = async (questionId, capsuleId) => {
    try {
        const response = await request.get(`/capsules/${capsuleId}/questions/${questionId}/explain`);
        return response.data; // Return the explanation data
    } catch (error) {
        console.error("Error fetching explanation for answer:", error);
        throw error; // Throw error to be handled by the caller
    }
}

export const giveComment = async (capsuleId, commentText) => {
    try {
        const response = await request.post(`/capsules/giveComment`, { capsuleId, commentText });
        return response.data; // Return the response data
    } catch (error) {
        console.error("Error giving comment:", error);
        throw error; // Throw error to be handled by the caller
    }
}
export const giveReaction = async (capsuleId, reactionType) => {
    try {
        const response = await request.post(`/capsules/giveReaction`, { capsuleId, reactionType});
        return response.data; // Return the response data
    } catch (error) {
        console.error("Error giving reaction:", error);
        throw error; // Throw error to be handled by the caller
    }
}

export const getCapsuleComments = async (capsuleId) => {
    try {
        const response = await request.get(`/capsules/${capsuleId}/comments`);
        return response.data; // Return the comments data
    } catch (error) {
        console.error("Error fetching capsule comments:", error);
        throw error; // Throw error to be handled by the caller
    }
}
